var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "100px",
          "search-btn-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
          "tooltip-config": { showAll: false, enterable: false },
          "is-list": "",
          "before-query-search": _vm.beforeQuerySearch,
        },
        on: {
          afterFetchOriginalData: _vm.getLowTableData,
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "SKU", prop: "sku" } },
                      [
                        _c("BjInputCode", {
                          attrs: {
                            placeholder: _vm.$t("InternalOrder.number"),
                            comma: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.sku,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "sku", $$v)
                            },
                            expression: "queryParams.sku",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("goodsPage.buyerName"),
                          prop: "buyerName",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.buyerName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "buyerName", $$v)
                            },
                            expression: "queryParams.buyerName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessPurchaseOrderList.type"),
                          prop: "type",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            clearable: false,
                            "option-list": _vm.PURCHASE_TYPE_NUMBER,
                          },
                          model: {
                            value: _vm.queryParams.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "type", $$v)
                            },
                            expression: "queryParams.type",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessPurchaseCostDown.statistics"),
                          prop: "isCost",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            clearable: false,
                            "option-list": _vm.STATUS_YES_TRUE,
                          },
                          model: {
                            value: _vm.queryParams.isCost,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "isCost", $$v)
                            },
                            expression: "queryParams.isCost",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessPurchaseCostDown.Base"),
                        },
                      },
                      [
                        _c("BjDatePicker", {
                          model: {
                            value: _vm.queryParams.creationDateBegin,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "creationDateBegin",
                                $$v
                              )
                            },
                            expression: "queryParams.creationDateBegin",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessPurchaseCostDown.Calculate"),
                        },
                      },
                      [
                        _c("BjDateTimerPicker", {
                          model: {
                            value: _vm.queryParamsTime_documentDate,
                            callback: function ($$v) {
                              _vm.queryParamsTime_documentDate = $$v
                            },
                            expression: "queryParamsTime_documentDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("el-col", { attrs: { span: _vm.colSpan } }, [
                  _c("div", { staticStyle: { width: "30px", height: "10px" } }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onExport },
                      },
                      [_vm._v(_vm._s(_vm.$t("exportText")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                            "show-overflow-tooltip":
                              col.prop !== "bjTableAction",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "sku"
                                      ? [
                                          _c("span", { staticClass: "link" }, [
                                            _vm._v(_vm._s(scope.row[col.prop])),
                                          ]),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row[col.prop],
                                            },
                                          }),
                                        ]
                                      : col.prop === "contractNo"
                                      ? [
                                          _c("span", { staticClass: "link" }, [
                                            _vm._v(_vm._s(scope.row[col.prop])),
                                          ]),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row[col.prop],
                                            },
                                          }),
                                        ]
                                      : col.prop === "creationDate"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeFilters")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "isCost"
                                      ? _c("el-switch", {
                                          attrs: {
                                            "active-value": true,
                                            "inactive-value": false,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.switchButton(
                                                $event,
                                                scope.row
                                              )
                                            },
                                          },
                                          model: {
                                            value: scope.row[col.prop],
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, col.prop, $$v)
                                            },
                                            expression: "scope.row[col.prop]",
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        {
          staticStyle: {
            "margin-right": "15px",
            "margin-top": "15px",
            float: "right",
            color: "#082dc3",
            "font-weight": "700",
            "font-size": "23px",
          },
        },
        [
          _vm._v(_vm._s(_vm.$t("BusinessPurchaseCostDown.Total")) + " ： "),
          _c("span", { staticStyle: { color: "#082dc3" } }, [
            _vm._v(_vm._s(_vm.total)),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }